export default __webpack_public_path__ + "static/dayuse-7d1985fa1733956cf578a4eefa07bd48.jpg";